import { render } from "./LessonContainer.vue?vue&type=template&id=a4f49124"
import script from "./LessonContainer.vue?vue&type=script&lang=js"
export * from "./LessonContainer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__